export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.115 5.115a7.221 7.221 0 0110.87 9.456l5.222 5.222-1.414 1.414-5.222-5.222a7.221 7.221 0 01-9.456-10.87zm8.8 1.414a5.223 5.223 0 10-7.386 7.387 5.223 5.223 0 007.386-7.387z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};